module.exports = __webpack_public_path__ + "static/media/la_consigne.dad78600.png";